/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".img-preview-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.img-preview-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:250px;max-height:250px;border:2px dashed #e0e0e0!important;padding:3px}"];
export { styles as styles };
